import { Collapsible } from 'components/shared/Collapsible'
import { AccordionContentProps } from './AccordionContent.types'

export const AccordionContent = ({
    children,
    isExpanded = false,
    id,
    'data-testid': testId,
}: AccordionContentProps) => (
    <Collapsible
        id={`panel-${id}`}
        isExpanded={isExpanded}
        aria-labelledby={`header-${id}`}
        data-testid={testId}
    >
        {children}
    </Collapsible>
)
